import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { LucideAngularModule } from 'lucide-angular';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-placeholder-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    CardModule,
    ButtonModule,
    LucideAngularModule,
    RouterModule
  ],
  template: `
    <div class="w-full min-h-full flex items-center justify-center p-8 bg-gradient-to-br from-primary-50 to-greyscale-50 md:p-4">
      <div class="w-full max-w-2xl">
        <p-card class="text-center">
          <div class="flex flex-col items-center gap-6">
            <div class="text-primary-500 opacity-70">
              <lucide-icon [name]="icon" [size]="64"></lucide-icon>
            </div>
            
            <h1 class="font-cabin text-4xl font-bold text-greyscale-900 m-0 md:text-2xl">
              {{ title | transloco }}
            </h1>
            
            <p class="text-xl text-primary-600 font-semibold m-0 md:text-lg">
              {{ 'pages.comingSoon' | transloco }}
            </p>
            
            <p class="text-base text-greyscale-600 m-0 leading-relaxed">
              {{ 'pages.comingSoonDescription' | transloco }}
            </p>
            
            <div class="mt-4">
              <p-button 
                severity="secondary"
                [label]="'pages.backToHome' | transloco"
                icon="pi pi-home"
                routerLink="/home/travel-board"
              />
            </div>
          </div>
        </p-card>
      </div>
    </div>
  `,
  styles: [`
    :host ::ng-deep {
      --p-card-body-padding: 3rem;
    }
    
    @media (max-width: 768px) {
      :host ::ng-deep {
        --p-card-body-padding: 2rem 1.5rem;
      }
    }
  `]
})
export class PlaceholderPageComponent {
  @Input() title: string = 'pages.defaultTitle';
  @Input() icon: string = 'construction';
}